import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";

import { useDispatch, useSelector } from "react-redux";
import { getAllLevels } from "../../../redux/features/assessmentToolSlice";
import { LEVEL_TABLE_HEAD } from "../../../components/datagrid/myworkspace/speakpro/level/LevelTableHead";
import CreateUpdateLevel from "../../../components/datagrid/myworkspace/speakpro/level/CreateUpdateLevel";

const MatrixLevel = () => {
  const [gridSize, setGridSize] = useState(10);
  const dispatch = useDispatch();
  const { levelData, loading } = useSelector((state) => state.assessmentTool);
  const profile = JSON.parse(localStorage.getItem("cred")).profile;
  useEffect(() => {
    dispatch(getAllLevels(profile?.departmentId));
  }, []);

  return (
    <GlobalWrapper title={"Matrix Level"} actions={<CreateUpdateLevel />}>
      <Paper elevation={3}>
        <Box sx={{ width: "100%", padding: 0 }}>
          <DataGrid
            disableVirtualization
            components={{ Toolbar: CustomGridToolbar }}
            loading={loading}
            autoHeight
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                textOverflow: "clip",
                whiteSpace: "break-spaces",
                lineHeight: 1,
              },
            }}
            // getRowHeight={() => "auto"}
            rows={levelData}
            columns={LEVEL_TABLE_HEAD}
            getRowId={(row) => row.serialNumber}
            pageSize={gridSize}
            rowsPerPageOptions={[5, 10, 25, 50]}
            onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
          />
        </Box>
      </Paper>
    </GlobalWrapper>
  );
};

export default MatrixLevel;
